// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getRemoteConfig,
  fetchAndActivate,
  getValue,
} from "firebase/remote-config";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCdqz8HJY6EDspRefPyps-jFFnyfwwgEeI",
  authDomain: "coalicion-loyalty-program.firebaseapp.com",
  projectId: "coalicion-loyalty-program",
  storageBucket: "coalicion-loyalty-program.appspot.com",
  messagingSenderId: "126566640340",
  appId: "1:126566640340:web:277811685fd4629faca941",
  measurementId: "G-FJM27BSGNX",
};

// Initialize Firebase
const getRemoteConfigByKey = async (key, content = null) => {
  const app = initializeApp(firebaseConfig);
  const remoteConfig = getRemoteConfig(app);
  remoteConfig.settings.minimumFetchIntervalMillis = 15000;
  remoteConfig.settings.minimumFetchIntervalMillis = 15;
  const isFetched = await fetchAndActivate(remoteConfig);
  if (isFetched) {
    content = getValue(remoteConfig, key);
  } else {
    content = getValue(remoteConfig, key);
  }
  return content;
};

const pullRemote = async (key, isJson = false) => {
  if (!key) return "";
  const content = await getRemoteConfigByKey(`coalition_${key}_reduced`);
  const res = isJson ? JSON.parse(content["_value"]) : content["_value"];
  return res;
};

export const getFaqs = async () => await pullRemote("faqs", true);
export const getTerms = async () => await pullRemote("terms");
export const getPrivacy = async () => await pullRemote("privacy");
export const getCookies = async () => await pullRemote("cookies");
